<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Tc Expense No：{{
            formData.tcExpenseNo ? formData.tcExpenseNo : 'New'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.tcExpenseStatus === 'Y'
              ? 'success'
              : formData.tcExpenseStatus === 'S'
              ? 'warning'
              : formData.tcExpenseStatus === 'D' ||
                formData.tcExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_tcExpenseStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyTime ? formData.modifyTime : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPersonName') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDateEndOpt"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_estimatedPaymentDate') || '预计付款日期'"
          >
            <el-date-picker
              v-model="formData.estimatedPaymentDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_tcRequestType') || '请款类型'"
            prop="tcRequestType"
          >
            <dict-select
              v-model="formData.tcRequestType"
              url="/master/common/dict/biz"
              :body="tcRequestTypeParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_expensePayerName') || '费用付款方'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              url="/master/common/dict/biz"
              :selectedLabel.sync="formData.expensePayerName"
              :body="expensePayerParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_payeeScm') || '收款供应商'"
            prop="payeeScmCode"
          >
            <dict-select
              v-model="formData.payeeScmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
              @change="payeeScmChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_payeeScmBankName') || '收款方开户银行'"
            prop="bankName"
          >
            <el-input v-model="formData.bankName" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePayScmBank"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountName') || '收款方账户名称'
            "
          >
            <el-input v-model="formData.bankAccountName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountNo') || '收款方银行账号'
            "
          >
            <el-input v-model="formData.bankAccountNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountType') ||
                '收款方银行账户性质'
            "
          >
            <el-input v-model="formData.v_bankAccountType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountKind') ||
                '收款方银行账号类别'
            "
          >
            <el-input v-model="formData.v_bankAccountKind" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="formData.currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              :body="currencyUnitParams"
              url="/master/common/dict/biz"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '付款用途'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_description') || '付款说明（不打印）'"
          >
            <el-input
              v-model="formData.description"
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_notes') || '备注'">
            <el-input
              v-model="formData.notes"
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :tcExpenseCode="tcExpenseCode"
          :depCode="depCode"
          :fullName="fullName"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :tcExpenseCode="tcExpenseCode"
        />
      </el-row>
    </el-form>
    <ChooseBank
      :visible.sync="chooseScmBankVisible"
      :title="$l('dialog_title_choose_payeeScmBank') || '选择收款方银行信息'"
      @confirm="chooseScmBankConfirm"
      :payeeScmCode="formData.payeeScmCode"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import ChooseBank from '../choose-bank'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable, ChooseBank },
  mixins: [EditLoading],
  props: {
    tcExpenseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      chooseScmBankVisible: false,
      tcRequestTypeParams: { dictType: 'tcRequestType' },
      expensePayerParams: { dictType: 'expensePayer' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      depCode: '',
      fullName: '',
      requestDateEndOpt: this.requestDateEnd(),
      formData: {
        tcRequestType: '',
        salesPersonCode: '',
        payeeScmCode: '',
        currencyAmount: 0,
        rmbAmount: 0,
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        v_bankAccountType: '',
        bankAccountKind: '',
        v_bankAccountKind: '',
        remark: '',
        description: '',
        notes: '',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        tcRequestType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        bankName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    'formData.salesPersonCode': {
      handler(val) {
        if (val) {
          this.findSalePersonDep()
        }
      },
      immediate: true,
    },
    info: {
      handler(userInfo) {
        if (this.tcExpenseCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    // 申请日期限制
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.tcExpenseCode) return
      this.$api
        .tcExpenseDetailApi({
          tcExpenseCode: this.tcExpenseCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    findSalePersonDep() {
      this.$api
        .tcExpenseFindDepApi({
          salesPersonCode: this.formData.salesPersonCode,
        })
        .then((res) => {
          this.depCode = res.body.depCode
          this.fullName = res.body.fullName
          this.$forceUpdate()
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || listItem.length < 1) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }
      const listDoc = this.$refs.docTable.getTableData()

      this.loadingOpen()
      this.$api
        .tcExpenseSaveApi({ ...this.formData, listItem, listDoc })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.tcExpenseCode) {
            this.closeCurPage()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    //获取供应商银行账户信息
    async payeeScmChange(scmCode) {
      if (!scmCode) {
        this.setBankData([])
        return
      }
      this.$api
        .masterScmInfoBankListApi({
          scmCode,
        })
        .then((res) => {
          this.setBankData(res.body.data)
        })
        .catch(() => {})
    },
    //给银行信息赋值
    setBankData(scmInfoBankList) {
      const bankData =
        !scmInfoBankList || scmInfoBankList.length > 1
          ? {}
          : scmInfoBankList[0] || {}
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = bankData
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
      //给formData重新赋值界面不更新,重新渲染组件
      this.$forceUpdate()
    },
    openChoosePayScmBank() {
      const { payeeScmCode } = this.formData
      if (!payeeScmCode) {
        this.$message({
          message:
            this.$l('tips_please_select_the_payeeScmName_first') ||
            '请先选择收款供应商',
          type: 'warning',
        })
        return
      }
      this.chooseScmBankVisible = true
    },
    chooseScmBankConfirm(e) {
      if (!e) return
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = e
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
    },
    initBank() {
      this.formData.bankName = ''
      this.formData.bankAccountName = ''
      this.formData.bankAccountNo = ''
      this.formData.bankAccountType = ''
      this.formData.v_bankAccountType = ''
      this.formData.bankAccountKind = ''
      this.formData.v_bankAccountKind = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
